import React, { useEffect, useState } from 'react';

const ProfessionalSummaryModal = ({ isOpen, onClose, initialText = '', onSave, onEnhance }) => {
	const [draft, setDraft] = useState(initialText || '');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setDraft(initialText || '');
	}, [initialText, isOpen]);

	if (!isOpen) return null;

	const handleEnhance = async () => {
		if (!onEnhance) return;
		try {
			setLoading(true);
			const enhanced = await onEnhance(draft || '');
			if (enhanced) setDraft(enhanced);
		} catch (err) {
			console.error('Modal enhance error', err);
		} finally {
			setLoading(false);
		}
	};

	const handleSave = () => {
		if (onSave) onSave(draft || '');
	};

	return (
		<div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, background: 'rgba(0,0,0,0.4)' }}>
			<div style={{ width: 720, maxWidth: '95%', background: '#fff', borderRadius: 6, padding: 20, boxShadow: 'rgba(0,0,0,0.2) 0px 6px 24px' }}>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
					<h3 style={{ margin: 0 }}>Edit Professional Summary</h3>
					<button aria-label="Close" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20 }}>×</button>
				</div>

				<textarea
					rows={12}
					className="form-textarea"
					value={draft}
					onChange={(e) => setDraft(e.target.value)}
					style={{ width: '100%' }}
				/>

				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginTop: 12 }}>
					<div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
						<button type="button" className="btn btn-secondary" onClick={handleEnhance} disabled={loading}>{loading ? 'Enhancing...' : 'Enhance'}</button>
					</div>
					<div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
						<button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProfessionalSummaryModal;
